import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)

import { onMounted, ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import VueTagsInput from "@sipec/vue3-tags-input";
import { CustomReportApiModel } from "../api-models";
import { validationErrors, CustomReportMemberTag } from "./custom-report-api-model";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-report-editor',
  props: {
    group: {},
    availableMemberTags: {},
    redirectUrlBase: {},
    patchUrl: {}
  },
  emits: ["dialog-closed", "dialog-opened"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const errors = ref<string[]>([]);
const shown = ref(false);
const tag = ref("");
const groupClone = ref<CustomReportApiModel>({} as any);

const tagValidation = [
  {
    classes: "lacks-report",
    rule: (memberTag: CustomReportMemberTag): boolean => !memberTag.hasReport,
  },
];

const autocompleteItems = () => {
  return props.availableMemberTags.filter((i) => {
    return i.text.toLowerCase().includes(tag.value.toLowerCase());
  });
};

const overlay = (from: CustomReportApiModel, on: CustomReportApiModel): void => {
  on.id = from.id;
  on.memberTags = on.memberTags ?? [];
  on.memberTags.length = 0;
  from.memberTags.forEach((x) => on.memberTags.push(x));
  on.name = from.name;
  on.kind = from.kind;
};

const open = (): void => {
  setTimeout(() => {
    shown.value = true;
  }, 200);
  emit("dialog-opened");
};

const close = (): void => {
  shown.value = false;
  setTimeout(() => {
    emit("dialog-closed");
  }, 1000);
};

const cancel = (): void => {
  close();
};

const validate = (): void => {
  const localErrors = validationErrors(groupClone.value);
  errors.value = localErrors;
};

const ok = (): void => {
  validate();
  if (errors.value.length === 0) {
    const href = `${props.redirectUrlBase}/${groupClone.value.id || ""}`.replace("//", "/");
    const newTab = window.open("", "_blank");

    axios
      .patch(props.patchUrl, groupClone.value)
      .then(() => {
        overlay(groupClone.value, props.group);
        if (errors.value.length === 0) {
          if (newTab) {
            newTab.location.href = href;
          } else {
            window.location.href = href;
          }
          close();
        }
      })
      .catch(() => {
        errors.value.push(
          "There was a problem. Please check your internet connection and try again.",
        );
        if (newTab !== null) {
          newTab.close();
        }
      });
  }
};

onMounted(() => {
  overlay(props.group, groupClone.value);
});

const getGroup = (): CustomReportApiModel => {
  return groupClone.value;
};

__expose({
  open,
  close,
  cancel,
  validate,
  ok,
  getGroup,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    class: "custom-report-editor",
    "append-to-body": true,
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shown).value = $event)),
    title: 
      'Editing - ' + ((groupClone.value.name || '').length > 0 ? groupClone.value.name : 'Untitled Report')
    ,
    "data-test": "custom-report-editor"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel())),
          "data-test": "custom-report-editor-cancel-button",
          type: "button"
        }, " Cancel "),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (ok())),
          "data-test": "custom-report-editor-ok-button",
          type: "button"
        }, " OK ")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control input-lg",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupClone.value.name) = $event)),
          style: {"width":"100%","max-width":"100%"},
          placeholder: "Give this report a title",
          "data-test": "custom-report-editor-name-input",
          "aria-label": "Give this report a title"
        }, null, 512), [
          [_vModelText, groupClone.value.name]
        ]),
        _hoisted_2,
        _createVNode(_unref(VueTagsInput), {
          style: {"width":"100%"},
          class: "form-control input-lg text-left",
          modelValue: tag.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tag).value = $event)),
          placeholder: 'Enter names...',
          maxlength: 128,
          "max-tags": 200,
          tags: groupClone.value.memberTags,
          validation: tagValidation,
          onTagsChanged: _cache[2] || (_cache[2] = (newTags) => (groupClone.value.memberTags = newTags)),
          "add-on-key": [13, 9, ':', ';'],
          "autocomplete-items": autocompleteItems(),
          "add-only-from-autocomplete": true,
          "autocomplete-min-length": 0,
          "data-test": "custom-report-editor-tags-input"
        }, null, 8, ["modelValue", "tags", "autocomplete-items"]),
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "text-danger text-left",
            key: error
          }, _toDisplayString(error), 1))
        }), 128)),
        _hoisted_4
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})